import { date as DateUtils } from 'quasar';

export class DateFormatter {
  static destinationTimeZone = 'Europe/Warsaw';

  static getDateFormat(): string {
    return 'DD-MM-YYYY';
  }

  static getDateTimeFormat(): string {
    return 'DD-MM-YYYY HH:mm';
  }

  static getTimeFormat(): string {
    return 'HH:mm';
  }

  static toDateString(date: Date): string {
    return DateUtils.formatDate(date, DateFormatter.getDateFormat());
  }

  static fromDateString(date: string): Date {
    return DateUtils.extractDate(date, DateFormatter.getDateFormat());
  }

  static toTimeString(date: Date): string {
    return DateUtils.formatDate(date, this.getTimeFormat());
  }

  static fromDateTimeString(dateTime: string): Date {
    return DateUtils.extractDate(dateTime, DateFormatter.getDateTimeFormat());
  }

  static changeTimeZone(date: Date, timeZone: string): Date {
    const longOffsetFormatter = new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone,
      timeZoneName: 'longOffset',
    });
    const longOffsetString = longOffsetFormatter.format(date);
    const gmtOffset = longOffsetString.split('GMT')[1];

    return new Date(`${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}T${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:00.000${gmtOffset}`);
  }
}
